let Format = {
  addZero(v) {
    return v < 10 ? "0" + v : v;
  },
};
export function timeChange(value) {
  if (!value) {
    return "";
  }
  let date = new Date(value);
  let year = date.getFullYear();
  let month = date.getMonth() + 1;
  let day = date.getDate();
  let time = `${Format.addZero(year)}-${Format.addZero(month)}-${Format.addZero(
    day
  )}`;
  // console.log(time);
  return time;
}
